@if (structuredData && fieldGroups) {
  <div class="structured-data">
    @for (itemSTD of structuredData | keyvalue; track itemSTD) {
      <div>
        @for (item of itemSTD.value | keyvalue; track item) {
          <div class="item d-flex pb-3">
            <span class="flex-it min-30p d-flex flex-xcontent-center">
              <div class="field-type-icon">
                <ng-icon
                  [name]="
                    {
                      type:
                        $any(item.key)
                        | typeField: fieldGroups : STRUCTURED_GROUP,
                    } | setFieldIcon: STRUCTURED_GROUP : 'icon'
                  "
                  [style.color]="
                    {
                      type:
                        $any(item.key)
                        | typeField: fieldGroups : STRUCTURED_GROUP,
                    } | setFieldIcon: STRUCTURED_GROUP : 'color'
                  "
                  [matTooltip]="
                    'Field Type: ' +
                    ($any(item.key) | typeField: fieldGroups : STRUCTURED_GROUP)
                  "
                  class="field-type-icon"
                  [attr.aria-label]="
                    'Field type ' +
                    ($any(item.key) | typeField: fieldGroups : STRUCTURED_GROUP)
                  "
                ></ng-icon>
              </div>
              <span class="label">
                {{ $any(item.key) | slice: 0 : 20 }}
              </span>
              @if ($any(item.key) | isLongText) {
                <span
                  class="dots mousePointer"
                  [matTooltip]="item.key"
                  matTooltipPosition="above"
                  >...</span
                >
              }
            </span>
            <span class="flex-fill">{{ item.value }}</span>
          </div>
        }
      </div>
    }
  </div>
}
